export default __webpack_public_path__ + "static/media/January2013.383d2b08.png";